
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Label } from 'reactstrap';
// import {FaQuestionCircle, FaPrint} from 'react-icons/fa';
import { getUserPreferences } from '../../../../action/cultureAction';
import { Redirect } from 'react-router-dom';

class GeneralPreferences extends Component {

    componentWillMount() {
        this.props.getUserPreferences();
    }

    constructor(props) {
        super(props)
        this.state = {
            data_in_state: null,
            Redirect: false
        };
        this.RedirectToEditPage = this.RedirectToEditPage.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({ data_in_state: nextProps.store_response });
        }
    }

    RedirectToEditPage(){
        this.setState({Redirect:true});
    }

    render(getLabels, getDMLabels) {
        let label, DMlabel, regional_settings, datadisplay_settings;
        let UnitSystem, cultureText;
        let { data_in_state } = this.state;

        label = this.props.getLabels;
        DMlabel = this.props.getDMLabels;

        if(this.state.Redirect){
            return <Redirect to={"/SystemAdmin/EditGeneralPreferences"} />
        }

        if (data_in_state !== null && data_in_state !== "" && label !== undefined && DMlabel !== undefined) {
            //console.log(data_in_state);

            regional_settings = <tbody>
                <tr><th>{label['EditPreferences.Columns.Setting.Text']}</th><th >{label["EditPreferences.Columns.Value.Text"]} </th></tr>
                <tr><td>{label['EditPreferences.Columns.Language.Text']}</td><td >{data_in_state.cultureText} </td></tr>
                <tr><td>{label['EditPreferences.Columns.DateFormat.Text']}</td><td >{label["EditPreferences.DateFormat." + data_in_state.dateFormatText + ".Text"]} </td></tr>
                <tr><td>{label['EditPreferences.Columns.TimeFormat.Text']}</td><td >{label["EditPreferences.TimeFormat." + data_in_state.timeFormatText + ".Text"]} </td></tr>
                <tr><td>{label['EditPreferences.Columns.NumberFormat.Text']}</td><td >{label["EditPreferences.NumberFormat." + data_in_state.numberFormatText + ".Text"]} </td></tr>
                <tr><td>{label['EditPreferences.Columns.DateSeparators.Text']}</td><td >{label["EditPreferences.DateSeparators." + data_in_state.dateSeparatorText + ".Text"]} </td></tr>
            </tbody>

            cultureText = data_in_state.regionalSettings === 1 ? label['Preferences.CurrentRegionalSettingValue.Custom.Text'] : data_in_state.cultureText;
            if(data_in_state.unitSystem === 0)
                UnitSystem = label['EnumPreferences.cboUnitSystem.IP.Text'];
            else if(data_in_state.unitSystem === 1)
                UnitSystem = label['EnumPreferences.cboUnitSystem.SI.Text'];
            else
                UnitSystem = label['EditPreferences.rbtnCustom.Text'];

            //if(DMlabel !== null && DMlabel !== "" && data_in_state != null){
                datadisplay_settings = data_in_state.units.map((el,index) => (
                    <tr key={index}>
                        {/* <td>{label["EditPreferences.Dimension." + data_in_state.units[index].dimension + ".Text"]}</td>
                        <td>{DMlabel["Enum3047." + data_in_state.units[index].unit + ".Text"]}</td> */}
                        <td>{data_in_state.units[index].dimensionName}</td>
                        <td>{data_in_state.units[index].unitName}</td>
                    </tr>
                ));
            //}
        }

        return (
            <div className="main_container huge_container_data">
              <div className="clear">
                <h2 className="dbd_sub_heading">{label['Preferences.Title.Text'] !== undefined ? label['Preferences.Title.Text'] : "Preferences"} </h2>
                {/* <FaQuestionCircle className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" />
                <FaPrint className="dbd_right_icon Ensemble_Icon print_icon link_cursor"  /> */}
                &nbsp;
              </div>
                <Label className="sub_text">{label['Preferences.UserAssistance.Text'] !== undefined ? label['Preferences.UserAssistance.Text'] : "View your general, data display, and regional preferences. Click Edit to make changes."}</Label>
                <br />

                <div className="buttons_container">
                    <Button className="btn-black btn-md" onClick={this.RedirectToEditPage}>Edit</Button>
                </div>

                <div className="sub_text">
                    <legend className="form_sub_title">{label['EditPreferences.lblDisplayUnitsHeading.Text'] !== undefined ? label['EditPreferences.lblDisplayUnitsHeading.Text'] : "Data Display Units"}</legend>
                    <legend className="form_sub_title" style={{"width":"25%"}}>{label['Preferences.lblCurrentValue.Text'] !== undefined ? label['Preferences.lblCurrentValue.Text'] : "Current Value"}<div style={{"float":"right","font-weight":"100"}}>{UnitSystem}</div></legend>
                    
                    <div className="table_container">
                        <Table striped responsive className="Custom_table general_prefereces_tbl">
                            <tbody>
                                <tr><th>{label['Preferences.Columns.DataType.Text'] !== undefined ? label['Preferences.Columns.DataType.Text'] : "Data Type"}</th><th>{label['Preferences.Columns.Units.Text'] !== undefined ? label['Preferences.Columns.Units.Text'] : "Unit"}</th></tr>
                                {datadisplay_settings}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="sub_text">
                    <legend className="form_sub_title">{label['EditPreferences.lblRegionalSettingsHeading.Text'] !== undefined ? label['EditPreferences.lblRegionalSettingsHeading.Text'] : "Regional Settings"}</legend>
                    <legend className="form_sub_title" style={{"width":"25%"}}>{label['Preferences.CurrentRegionalSetting.Text'] !== undefined ? label['Preferences.CurrentRegionalSetting.Text'] : "Current Regional Settings"} <div style={{"float":"right","font-weight":"100"}}>{cultureText}</div></legend>
                    <div className="table_container">
                        <Table striped responsive className="Custom_table general_prefereces_tbl">
                            {regional_settings}
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
    };
};

const mapStateToProps = state => {
    return {
        store_response: state.userPreferencesRootReducer.UserPreference,
        getLabels: state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference,
        getDMLabels: state.CulturalLabelsRootReducer.DMResource_LabelsBasedOnPreference
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralPreferences);
